const statusEl = document.getElementById('loading-status');
if (statusEl) statusEl.textContent = '正在加载...';

async function main() {
  const { StandaloneGame } = await import('./StandaloneGame');
  new StandaloneGame('game-container').start();
}

main();
